import React from 'react';
import { GetStarted } from './style';
import { Icon } from 'antd';

// borderRadius - large, medium, small;
// backgroundColor - primary, danger, ghost;
// fontColor - primary, secondary;

const ActionButton = props => {
  const {
    label,
    className,
    disabled,
    loading,
    onClick,
    small,
    medium,
    large,
    borderRadius = 'small',
    backgroundColor = 'primary',
    fontColor = 'primary',
    enableShadow = false,
  } = props;
  return (
    <GetStarted
      disabled={disabled}
      small={small}
      medium={medium}
      large={large}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      fontColor={fontColor}
      enableShadow={enableShadow}
    >
      <button data-hover={label} className={className} onClick={onClick}>
        {loading && <Icon type="loading" className="loading" />}
        <div>{label}</div>
      </button>
    </GetStarted>
  );
};

export default ActionButton;